import { NgTemplateOutlet } from '@angular/common';
import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NavigationLink } from '@common';
import { IconComponent } from '../icon/icon.component';
import { DgxIconName } from '../icon/models/icon-name.type';

@Component({
  selector: 'app-link',
  templateUrl: './link.component.html',
  styleUrl: './link.component.scss',
  imports: [IconComponent, NgTemplateOutlet, RouterLink],
})
export class LinkComponent {
  href = input<string | undefined>(undefined);
  hyperlink = input<boolean>(false);
  iconName = input<DgxIconName | undefined>(undefined);
  iconPosition = input<'left' | 'right'>('left');
  navigationLink = input<NavigationLink | undefined>(undefined);
  newWindow = input<boolean>(false);
  routerPath = input<string | undefined>(undefined);
  tabIndex = input<number | undefined>(undefined);
}
